<template>
    <div>
        <!--begin::App-->
        <div class="d-flex flex-column flex-root app-root ct-theme-aes big-wp-theme-aes" id="kt_app_root">
            <!--begin::Page-->
            <div class="app-page flex-column flex-column-fluid" id="kt_app_page" v-if="isInitialized">
                <KTHeader />
                <!--begin::Wrapper-->
                <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
                    <KTSidebar/>
                    <!--begin::Main-->
                    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
                        <!--begin::Content wrapper-->
                        <div class="d-flex flex-column flex-column-fluid">
                            <!--<KTToolbar />-->
                            <!--<div id="kt_app_content" class="app-content flex-column-fluid">

        </div>-->
                            <RouterView></RouterView>
                        </div>
                        <!--end::Content wrapper-->
                        <KTFooter />
                    </div>
                    <!--end:::Main-->
                </div>
                <!--end::Wrapper-->
            </div>
            <!--end::Page-->
        </div>
        <!--end::App-->

        <KTDrawers />
        <KTScrollTop />
        <KTModals />
        <KTCustomize />
        <common-check-session />
        <common-check-version />
        <notification-service-worker/>
        
        <!-- Payment Notification Modal -->
        <payment-notification-modal 
            :receipts="paymentReceipts" 
            :is-visible="showPaymentModal"
            @close="closePaymentModal" />
            
        <!-- Toast Container -->
        <ToastContainer />
    </div>
</template>

<script lang="ts">
    import { SignalRService } from "~/core/services/signalRService";
    import { getToken } from "@/core/services/JwtService";
    import {
        defineComponent,
        nextTick,
        onBeforeMount,
        onMounted,
        onUnmounted,
        watch,
    } from "vue";
    import KTHeader from "@/layouts/default-layout/components/header/Header.vue";
    import KTSidebar from "@/layouts/default-layout/components/sidebar/Sidebar.vue";
    import KTContent from "@/layouts/default-layout/components/content/Content.vue";
    import KTToolbar from "@/layouts/default-layout/components/toolbar/Toolbar.vue";
    import KTFooter from "@/layouts/default-layout/components/footer/Footer.vue";
    import KTDrawers from "@/layouts/default-layout/components/drawers/Drawers.vue";
    import KTModals from "@/layouts/default-layout/components/modals/Modals.vue";
    import KTScrollTop from "@/layouts/default-layout/components/extras/ScrollTop.vue";
    import KTCustomize from "@/layouts/default-layout/components/extras/Customize.vue";
    import PaymentNotificationModal from "@/components/common/payment-notification-modal.vue";
    import ToastContainer from "@/components/common/ToastContainer.vue";
    import { useRoute } from "vue-router";
    import { reinitializeComponents } from "@/core/plugins/keenthemes";
    import LayoutService from "@/core/services/LayoutService";
    import { useMessageBox } from "~/composables/useMessageBox";
    import type { ReceiptEntity } from "~/core/services/ApiClient";

    export default defineComponent({
        components: {
            KTHeader,
            KTSidebar,
            KTContent,
            KTToolbar,
            KTFooter,
            KTDrawers,
            KTScrollTop,
            KTModals,
            KTCustomize,
            PaymentNotificationModal,
            ToastContainer,
        },
        setup() {
            const token = getToken();
            if (token) {
                SignalRService.startConnection(token);
            }
            
            const route = useRoute();
            const isInitialized = ref(false);
            const systemStore = useSystemStore();
            const apiClient = useApiClient();
            const { showSuccess } = useMessageBox();
            let paymentInterval: NodeJS.Timeout | null = null;
            
            // Modal state
            const showPaymentModal = ref(false);
            const paymentReceipts = ref<ReceiptEntity[]>([]);
            
            onBeforeMount(async () => {
                 LayoutService.init();
                await systemStore.init();
                isInitialized.value = true;
                //systemStore.newsGetCount();
                reinitializeComponents();
            });
            
            watch(
                () => route.path,
                () => {
                    nextTick(() => {
                        reinitializeComponents();
                    });
                }
            );

            const startInterval = () => {
                if (paymentInterval) {
                    clearInterval(paymentInterval);
                }
                paymentInterval = setInterval(() => {
                    // Chỉ gọi checkPayment khi modal không đang hiển thị
                    if (!showPaymentModal.value) {
                        checkPayment();
                    }
                }, 10000); // 10 giây = 10000ms
            };

            const stopInterval = () => {
                if (paymentInterval) {
                    clearInterval(paymentInterval);
                    paymentInterval = null;
                }
            };

            const closePaymentModal = async () => {
                // Update IsNotify = true cho tất cả receipt
                if (paymentReceipts.value.length > 0) {
                    try {
                       await apiClient.receiptUpdatePaymentNotify(paymentReceipts.value.map(receipt => receipt.id) as number[])
                    } catch (error) {
                        console.error('Lỗi khi cập nhật IsNotify:', error);
                    }
                }
                
                showPaymentModal.value = false;
                paymentReceipts.value = [];
                // Tiếp tục interval khi đóng modal
                startInterval();
            };

            const checkPayment = () => {
                apiClient.receiptCheckPayment().then(res => {
                    console.log('Check payment result:', res);
                    // Kiểm tra xem có dữ liệu thanh toán không (res là ReceiptEntity[])
                    if (res && Array.isArray(res) && res.length > 0) {
                        // Dừng interval khi hiển thị modal
                        stopInterval();
                        // Hiển thị modal với danh sách phiếu thu
                        paymentReceipts.value = res;
                        showPaymentModal.value = true;
                    }
                }).catch(error => {
                    console.error('Error checking payment:', error);
                });
            }

            onMounted(() => {
                // Gọi lần đầu
                checkPayment();
                
                // Bắt đầu interval
                startInterval();
            });

            onUnmounted(() => {
                // Clear interval khi component bị unmount
                stopInterval();
            });

            return {
                isInitialized,
                showPaymentModal,
                paymentReceipts,
                closePaymentModal
            }
        },
    });
</script>

<style>
    .btn.btn-icon {
        padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
    }
</style>